import React, {useEffect} from "react";
import FileSave from "../utils/FileSave"; // in use, do not remove
import {Vector3} from "three";

const CamaraPosRecorder = ({orbit}) => {
  
  const totalPositions = 8;
  
  useEffect(() => {
    
    let camPositions = {};
    let posIndex = 0;
    
    const setPosReview = (camPositions, value) => {
      
      orbit.current["object"].position.x = camPositions[value].pos.x;
      orbit.current["object"].position.y = camPositions[value].pos.y;
      orbit.current["object"].position.z = camPositions[value].pos.z;
      
      orbit.current.target = new Vector3(
        camPositions[value].target.x,
        camPositions[value].target.y,
        camPositions[value].target.z
      );
    }
    
    let camControlPanel;
    
    const initSetPosUi = () => {
      
      const cameraControlRecorderPanel =
        
        '<div style="display: block" id="camControlPanel" class="dev-camera-section">' +
          '<div class="cam-pos-header">' +
            'set camera positions' +
          '</div>' +
          '<div class="cam-pos btn">' +
            'record position' +
          '</div>' +
          '<ul class="cam-output-list"> </ul>' +
          '<div class="cam-pos-remove">' +
            '<span> remove last</span>' +
          '</div>' +
          '<div class="cam-pos-save">' +
            '<span>Save</span>' +
          '</div>' +
        '</div>'
      
      document.body.insertAdjacentHTML('beforeend', cameraControlRecorderPanel);
      camControlPanel = document.getElementById('camControlPanel');
      const camPosBtn = camControlPanel.getElementsByClassName('cam-pos')[0];
      const camOutput = camControlPanel.getElementsByClassName('cam-output-list')[0];
      const removePosBtn = camControlPanel.getElementsByClassName('cam-pos-remove')[0];
      const saveBtn = camControlPanel.getElementsByClassName('cam-pos-save')[0];
      
      // control btns
      
      camPosBtn.addEventListener('click', function () {
        
        if (camOutput.childNodes.length > totalPositions) return;
        
        const liEle = document.createElement('li');
        
        // review btn
        liEle.addEventListener('click', function () {
          setPosReview(camPositions, this.innerHTML);
        });
        
        // set position
        posIndex += 1;
        liEle.innerHTML = 'camera_position_' + posIndex;
        
        camPositions['camera_position_' + posIndex] = {
          'pos': {...orbit.current["object"].position},
          'target': {...orbit.current.target}
        }
        
        camOutput.appendChild(liEle);
        
      });
      
      removePosBtn.addEventListener('click', function () {
        
        if (!camOutput.lastChild) return;
        
        delete camPositions[camOutput.lastChild.innerHTML];
        camOutput.lastChild.remove();
        posIndex -= 1;
        
      });
      
      saveBtn.addEventListener('click', function () {
        
        if (!camOutput.lastChild) return;
        
        let myFile = new File(
          [JSON.stringify(camPositions)],
          "camera-shots.json",
          {type: "text/plane;charset=utf8"}
        );
        saveAs(myFile);
      });
      
    }
    
    let displayInAction = false;
    
    // if in action - use ( Alt + c )
    window.addEventListener('keydown', function (event) {
      
      if (event.altKey && event.keyCode === 67) {
        
        if (!displayInAction) {
          
          initSetPosUi();
          displayInAction = true;
          
        } else {
          
          camControlPanel.remove();
          displayInAction = false;
          
        }
      }
    });
    
  }, []);
  
}

export default CamaraPosRecorder;
